<div class="highlighted-campaign-dialog" [class.text-only]="!campaign.mediaAsset">
  <button
    *ngIf="canDismiss"
    type="button"
    class="close-button"
    aria-label="Fechar campanha destacada"
    (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <header class="dialog-header">
    <span class="eyebrow">{{ campaignTypeLabel }}</span>
    <h1>{{ campaign.headline }}</h1>
  </header>

  <div class="dialog-main">
    <section class="media-panel" *ngIf="campaign.mediaAsset">
      <img
        *ngIf="isImageCampaign"
        class="campaign-image"
        [src]="campaign.mediaAsset.mediaUrl"
        [alt]="campaign.mediaAsset.altText || campaign.headline">

      <iframe
        *ngIf="shouldRenderEmbeddedVideo"
        #campaignVideoFrame
        class="campaign-video-frame"
        [src]="videoEmbedUrl"
        [title]="campaign.mediaAsset.title || campaign.headline"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen>
      </iframe>

      <video
        *ngIf="isVideoCampaign && !shouldRenderEmbeddedVideo"
        class="campaign-video"
        controls
        playsinline
        [poster]="videoPosterUrl || undefined"
        (play)="onHtml5VideoPlay()"
        (timeupdate)="onHtml5VideoTimeUpdate($event)"
        (ended)="onHtml5VideoEnded()">
        <source [src]="campaign.mediaAsset.mediaUrl">
        Seu navegador nao suporta a reproducao de video.
      </video>
    </section>

    <section class="content-panel">
      <div class="content-shell">
        <div class="content-body">
          <p *ngIf="campaign.bodyText" class="body-text">
            {{ campaign.bodyText }}
          </p>

          <div class="media-caption" *ngIf="campaign.mediaAsset?.title">
            {{ campaign.mediaAsset.title }}
          </div>
        </div>

        <div class="actions">
          <button
            *ngIf="whatsappLink"
            type="button"
            mat-flat-button
            class="cta-button"
            (click)="openWhatsApp()">
            <mat-icon svgIcon="whatsapp"></mat-icon>
            {{ campaign.whatsappCallToAction?.label || 'Falar no WhatsApp' }}
          </button>

          <button
            *ngIf="canDismiss"
            type="button"
            mat-flat-button
            class="secondary-action"
            color="primary"
            (click)="close()">
            Fechar
          </button>
        </div>
      </div>
    </section>
  </div>
</div>